(async () => {
    if (!customElements.get("product-animations")) {
        const {
            default: Swiper,
            EffectFade,
            Mousewheel
        } = await import("./swiper.esm-357e3607.async.js");
        Swiper.use([EffectFade, Mousewheel]);
        class ProductAnimations extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-product-animations-swiper]");
                const self = this;
                this.swiperOptions = {
                    loop: false,
                    observer: true,
                    threshold: 10,
                    slidesPerView: 1,
                    direction: "vertical",
                    speed: 750,
                    grabCursor: true,
                    effect: "fade",
                    fadeEffect: {
                        crossFade: true
                    },
                    mousewheel: {
                        sensitivity: 1,
                        forceToAxis: true
                    },
                    on: {
                        slideChangeTransitionStart: function(swiper) {
                            swiper.offsetTop = self.getOffsetTop()
                        },
                        slideChange: function(swiper) {
                            swiper.params.mousewheel.releaseOnEdges = false;
                            swiper.params.touchReleaseOnEdges = false;
                            window.scrollTo({
                                top: swiper.offsetTop,
                                behavior: "smooth"
                            })
                        },
                        reachBeginning: function(swiper) {
                            setTimeout((function() {
                                swiper.params.mousewheel.releaseOnEdges = true;
                                swiper.params.touchReleaseOnEdges = true
                            }), 1e3)
                        },
                        reachEnd: function(swiper) {
                            setTimeout((function() {
                                swiper.params.mousewheel.releaseOnEdges = true;
                                swiper.params.touchReleaseOnEdges = true
                            }), 1e3)
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                this.init();
                if (Shopify.designMode && this.swiperInstance) {
                    const sectionSettings = JSON.parse(this.closest("[data-shopify-editor-section]").dataset.shopifyEditorSection);
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }));
                    window.addEventListener("shopify:block:select", (event => {
                        if (event.detail.sectionId === sectionSettings.id) {
                            this.handleSectionEvents(event)
                        }
                    }))
                }
            }
            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
            }
            handleSectionEvents(event) {
                this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex))
            }
            getOffsetTop() {
                const thisElementHeight = this.getBoundingClientRect().height;
                let setOffsetTop = this.offsetTop;
                if (thisElementHeight < window.innerHeight) {
                    setOffsetTop = this.offsetTop - (window.innerHeight - thisElementHeight) / 2
                }
                return setOffsetTop
            }
        }
        window.ProductAnimations = ProductAnimations;
        customElements.define("product-animations", ProductAnimations)
    }
})();
//# sourceMappingURL=product-animations.js.map